export default "__VITE_ASSET__b62d1825__"